import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className"],
  _excluded2 = ["hovered"];
import useHovered from 'UIComponents/hooks/useHovered';
import UIFlex from 'UIComponents/layout/UIFlex';
import { getDataAttributes } from '../utils/getDataAttributes';
import classNames from 'classnames';
import { fullWidthCellClassName } from '../utils/fullWidthCellClassName';
import styled from 'styled-components';
import { HIGHLY_SENSITIVE_MASKED_DISPLAY } from '../dataSensitivity/highlySensitiveMaskedDisplay';
import { ShowHighlySensitiveValueButton } from '../dataSensitivity/ShowHighlySensitiveValueButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RelativeUIFlex = styled(UIFlex).withConfig({
  displayName: "FormattedHighlySensitive__RelativeUIFlex",
  componentId: "sc-1nespdm-0"
})(["position:relative;"]);
export const FormattedHighlySensitive = props => {
  const {
      className
    } = props,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded);
  const _useHovered = useHovered({}),
    {
      hovered
    } = _useHovered,
    hoveredProps = _objectWithoutPropertiesLoose(_useHovered, _excluded2);
  return /*#__PURE__*/_jsxs(RelativeUIFlex, Object.assign({
    className: classNames(className, fullWidthCellClassName)
  }, hoveredProps, getDataAttributes(otherProps), {
    align: "center",
    direction: "row",
    children: [/*#__PURE__*/_jsx("span", {
      className: "m-right-2",
      children: HIGHLY_SENSITIVE_MASKED_DISPLAY
    }), /*#__PURE__*/_jsx(ShowHighlySensitiveValueButton, {
      isVisible: hovered
    })]
  }));
};